<template>
    <div>
        <v-row>
            <v-col v-if="myProfile" cols="12">
                <v-btn color="primary" text rounded class="ml-4" @click="resetPassowrdResetForm()">
                    {{ t('dms-users::button.cancel') }}
                </v-btn>
                <v-btn
                    v-if="can('api.v1.auth.change-password')"
                    class="ml-4"
                    color="primary"
                    rounded
                    :loading="dmsUserChangePasswordFormLoading"
                    @click="tryChangePassword()"
                >
                    {{ t('dms-users::button.save') }}
                </v-btn>
            </v-col>
            <v-col v-if="!myProfile" cols="12">
                <v-btn color="primary" text rounded @click="$root.goTo($root.route('dms-users.index'))">
                    {{
                        !can('api.v1.dms-users.update')
                            ? t('dms-users::button.back_to_list')
                            : t('dms-users::button.cancel')
                    }}
                </v-btn>
                <v-btn
                    v-if="can('api.v1.dms-users.reset-password') && id"
                    color="primary"
                    text
                    rounded
                    :disabled="sentPassword"
                    class="ml-4"
                    :loading="dmsUserResetPassowrdFormLoading"
                    @click="resetUserPassword()"
                >
                    {{ t('dms-users::button.send_reset_password_link') }}
                </v-btn>
                <v-btn
                    v-if="can('api.v1.dms-users.update') || can('api.v1.dms-users.store')"
                    color="primary"
                    rounded
                    class="ml-4"
                    :loading="dmsUserSaveFormLoading"
                    @click="saveDmsUser()"
                >
                    {{ t('dms-users::button.save') }}
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    props: {
        myProfile: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            passowrdResetForm: null,
            sentPassword: false,
            dmsUserSaveFormLoading: false,
            dmsUserChangePasswordFormLoading: false,
            dmsUserResetPassowrdFormLoading: false,
        };
    },
    computed: {
        id() {
            return this.$store.state.dms_users.dms_user.id;
        },
    },
    created() {
        this.passowrdResetForm = this.$parent.$children.find((x) => x.$options.name === 'DmsUserPasswordChange');
    },
    methods: {
        async saveDmsUser() {
            this.dmsUserSaveFormLoading = true;
            this.$store.dispatch('dms_users/resetErrorMessages');
            return await axios({
                method: this.id ? 'put' : 'post',
                url: this.id
                    ? route('api.v1.dms-users.update', { dms_user: this.id })
                    : route('api.v1.dms-users.store'),
                data: this.$store.state.dms_users.dms_user,
            })
                .then(() => {
                    this.$store.dispatch('user/setEmail', this.$store.state.dms_users.dms_user.email);

                    if (this.id) {
                        this.$root.notify('info', t('default::notification.success'), t('users::notification.update'));
                    }

                    if (!this.id) {
                        this.$root.notify('info', t('default::notification.success'), t('users::notification.create'));
                    }
                    _.delay(() => {
                        this.$root.goTo(route('dms-users.index'));
                    }, 1000);
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        this.$store.dispatch('dms_users/setErrorMessages', error.response.data.errors);
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }
                })
                .finally(() => _.delay(() => (this.dmsUserSaveFormLoading = false), 400));
        },
        resetPassowrdResetForm() {
            if (!this.passowrdResetForm) {
                return false;
            }
            this.dmsUserFormLoading = true;
            this.passowrdResetForm.$refs.passwordReset.reset();
        },
        async tryChangePassword() {
            if (!this.passowrdResetForm) {
                return false;
            }
            if (!this.passowrdResetForm.isValid && !this.passowrdResetForm.$refs.passwordReset.validate()) {
                return false;
            }
            this.dmsUserChangePasswordFormLoading = true;
            return await axios({
                method: 'post',
                url: route('api.v1.auth.change-password'),
                data: this.$store.state.dms_users.password,
            })
                .then((response) => {
                    this.$root.notify('info', response.data.message);
                    this.$store.dispatch('dms_users/resetErrorMessages');
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        this.$store.dispatch('dms_users/setErrorMessages', {
                            errors: error.response.data.errors,
                            type: 'password',
                        });
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }
                })
                .finally(() => _.delay(() => (this.dmsUserChangePasswordFormLoading = false), 400));
        },
        async resetUserPassword() {
            this.dmsUserResetPassowrdFormLoading = true;
            return await axios({
                method: 'post',
                url: route('api.v1.dms-users.reset-password', { user: this.id }),
            })
                .then((response) => {
                    this.sentPassword = true;
                    this.$root.notify('info', response.data.message);
                })
                .catch((error) => {
                    this.$root.notify('error', error.response.data.error);
                })
                .finally(() => _.delay(() => (this.dmsUserResetPassowrdFormLoading = false), 400));
        },
    },
};
</script>

<style></style>
